import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import SpeedIcon from '@mui/icons-material/Speed';
import StorefrontIcon from '@mui/icons-material/Storefront';
import TimerIcon from '@mui/icons-material/Timer';
import TranslateIcon from '@mui/icons-material/Translate';
import { Box, Card, CardContent, Container, Divider, Grid, IconButton, Paper, Step, StepContent, StepLabel, Stepper, Typography, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';

export default function ProjectDetailsSection() {
    const theme = useTheme();
    const [ref, inView] = useInView({
        triggerOnce: true,
        threshold: 0.1,
    });

    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [autoPlay, setAutoPlay] = useState(true);

    const exampleQuestions = [
        {
            question: "Bu ürünün garantisi var mı? Kargo ne zaman gelir?",
            answer: "Merhaba, ürünümüz 2 yıl garantilidir. Siparişiniz onaylandıktan sonra 1-3 iş günü içerisinde Aras Kargo ile gönderilecektir. Cumartesi günleri de teslimat yapılmaktadır. Başka sorunuz olursa yardımcı olmaktan memnuniyet duyarız."
        },
        {
            question: "Boyum 175 cm, kilom 70 kg. Hangi bedeni sipariş etmeliyim?",
            answer: "Merhaba, verdiğiniz boy ve kilo ölçülerinize göre M beden sizin için uygun olacaktır. Ürünlerimiz normal kalıptır. Daha rahat bir kullanım isterseniz L beden de tercih edebilirsiniz. Herhangi bir sorunuz olursa yardımcı olmaktan memnuniyet duyarız."
        },
        {
            question: "Ürün yıkamada çeker mi? Nasıl yıkamalıyım?",
            answer: "Merhaba, ürünümüz %100 pamuklu kumaştan üretilmiştir. 30 derecede, hassas programda, ters çevirerek yıkamanızı öneririz. Kurutma makinesinde kurutulması önerilmez. Bu şekilde yıkadığınızda çekme yapmayacaktır. Ürün etiketinde de detaylı yıkama talimatları bulunmaktadır."
        },
        {
            question: "Ürünün rengi fotoğraftaki gibi mi? Daha önce sipariş ettiğim ürünün rengi farklı gelmişti.",
            answer: "Merhaba, ürün fotoğrafları profesyonel ekipmanlarla stüdyo ortamında çekilmiştir ve renk olarak gerçeğiyle birebir aynıdır. Telefon veya bilgisayar ekranınızın renk ayarlarına bağlı olarak küçük ton farklılıkları olabilir. Önceki siparişinizle ilgili yaşadığınız sorunu incelemek için sipariş numaranızı iletebilirsiniz, size yardımcı olmaktan memnuniyet duyarız."
        },
    ];

    useEffect(() => {
        let interval;
        if (autoPlay) {
            interval = setInterval(() => {
                setCurrentQuestionIndex((prevIndex) => (prevIndex + 1) % exampleQuestions.length);
            }, 5000);
        }
        return () => clearInterval(interval);
    }, [autoPlay, exampleQuestions.length]);

    const handlePrevQuestion = () => {
        setAutoPlay(false);
        setCurrentQuestionIndex((prevIndex) => (prevIndex - 1 + exampleQuestions.length) % exampleQuestions.length);
    };

    const handleNextQuestion = () => {
        setAutoPlay(false);
        setCurrentQuestionIndex((prevIndex) => (prevIndex + 1) % exampleQuestions.length);
    };

    const detailItems = [
        {
            icon: <SmartToyIcon />,
            title: 'Yapay Zeka Teknolojisi',
            description: 'Helpigo, en son GPT-4 teknolojisini kullanarak müşteri sorularını anlamlandırır ve doğal dil işleme yetenekleriyle insan benzeri yanıtlar üretir.'
        },
        {
            icon: <TimerIcon />,
            title: 'Hızlı Yanıt Üretimi',
            description: 'Helpigo sorulara 10 saniye içerisinde cevap üretir ve bu ürettiği cevabı kendisi tekrar puanlar.'
        },
        {
            icon: <CheckCircleIcon />,
            title: 'Akıllı Doğrulama Sistemi',
            description: 'Eğer puan 10 üzerinden 7 ve altında kalıyorsa müşteriye onaylaması için bildirim gönderir, 7 ve üzerinde ise otomatik Pazaryerleri\'ne gönderir.'
        },
        {
            icon: <HistoryIcon />,
            title: 'Geçmiş Verilerden Öğrenme',
            description: 'Helpigo geçmiş soruları ve cevapları da kullanarak cevap üretir, bu sayede daha önce 1 kere cevapladığınız bir soruyu tekrar cevaplamanıza asla gerek kalmaz.'
        },
        {
            icon: <StorefrontIcon />,
            title: 'Sınırsız Mağaza Desteği',
            description: 'Sınırsız Pazaryerleri Mağazası bağlayabilir ve tüm mağazalarınızı tek bir panelden yönetebilirsiniz.'
        },
        {
            icon: <TranslateIcon />,
            title: 'Özelleştirilebilir AI Dili',
            description: 'Mağazalara özel AI dili ve AI konuşma şekli belirleyerek markanızın kimliğini yansıtabilirsiniz.'
        },
        {
            icon: <SettingsIcon />,
            title: 'Mağaza Bilgilerini Özelleştirme',
            description: 'Mağazalara özel ürünler ve mağaza bilgileri belirleyerek (Örneğin kargo teslim süresi, çalışılan kargo firması) daha doğru yanıtlar verilmesini sağlayabilirsiniz.'
        },
        {
            icon: <SpeedIcon />,
            title: 'Performans Analizi',
            description: 'Detaylı analitik paneli ile hangi ürünlere daha çok soru geldiğini, ortalama yanıt süresini ve müşteri memnuniyetini ölçebilirsiniz.'
        }
    ];

    const workflowSteps = [
        {
            label: 'Müşteri Sorusu Gelir',
            description: 'Pazaryerleri üzerinden müşteri bir ürününüz hakkında soru sorar.',
            icon: <i className="fas fa-question-circle" />
        },
        {
            label: 'Helpigo Soruyu Analiz Eder',
            description: 'Yapay zeka, soruyu analiz eder ve mağaza bilgileriniz, ürün detayları ve geçmiş yanıtlarınızı kullanarak en uygun cevabı hazırlar.',
            icon: <i className="fas fa-brain" />
        },
        {
            label: 'Yanıt Kalitesi Değerlendirilir',
            description: 'Sistem, üretilen yanıtın kalitesini 10 üzerinden değerlendirir.',
            icon: <i className="fas fa-star-half-alt" />
        },
        {
            label: 'Yanıt Gönderilir veya Onaya Sunulur',
            description: 'Eğer yanıt kalitesi 7 ve üzerindeyse otomatik olarak Pazaryerleri\'ne gönderilir. Altındaysa size onay için bildirim gönderilir.',
            icon: <i className="fas fa-paper-plane" />
        },
        {
            label: 'Performans Takibi',
            description: 'Tüm yanıtlar ve performans metrikleri dashboard\'unuzda görüntülenir ve analiz edilir.',
            icon: <i className="fas fa-chart-line" />
        }
    ];

    return (
        <Box
            id="features"
            sx={{
                py: 10,
                background: 'white',
                color: theme.palette.text.primary,
            }}
        >
            <Container maxWidth="lg">
                <Box sx={{ textAlign: 'center', mb: 6 }}>
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                        viewport={{ once: true }}
                    >
                        <Typography
                            variant="h3"
                            component="h2"
                            sx={{
                                fontSize: { xs: '2rem', md: '2.5rem' },
                                fontWeight: 700,
                                mb: 2,
                                color: theme.palette.secondary.main,
                                position: 'relative',
                                display: 'inline-block',
                                '&::after': {
                                    content: '""',
                                    position: 'absolute',
                                    bottom: -10,
                                    left: '50%',
                                    transform: 'translateX(-50%)',
                                    width: 80,
                                    height: 4,
                                    backgroundColor: theme.palette.primary.main,
                                    borderRadius: 2
                                }
                            }}
                        >
                            <Box component="span" sx={{ color: theme.palette.primary.main }}>Helpigo</Box> Nasıl Çalışır?
                        </Typography>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <Typography
                            variant="body1"
                            sx={{
                                fontSize: { xs: '1rem', md: '1.1rem' },
                                color: theme.palette.text.secondary,
                                maxWidth: '800px',
                                mx: 'auto',
                                mb: 4,
                                mt: 4
                            }}
                        >
                            Helpigo, son teknoloji yapay zeka algoritmaları kullanarak müşteri sorularını anında yanıtlar.
                            Gelişmiş doğal dil işleme yetenekleri sayesinde müşteri sorularını doğru bir şekilde anlar ve
                            mağazanıza özel bilgileri kullanarak kişiselleştirilmiş yanıtlar üretir.
                        </Typography>
                    </motion.div>
                </Box>

                <Grid container spacing={6}>
                    <Grid item xs={12} md={6}>
                        <motion.div
                            ref={ref}
                            initial={{ opacity: 0, x: -30 }}
                            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
                            transition={{ duration: 0.5 }}
                        >
                            <Typography
                                variant="h4"
                                component="h3"
                                sx={{
                                    fontWeight: 600,
                                    mb: 4,
                                    color: theme.palette.secondary.main,
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <AutoAwesomeIcon sx={{ mr: 1, color: theme.palette.primary.main }} />
                                Çalışma Prensibi
                            </Typography>

                            <Stepper orientation="vertical" sx={{ mb: 4 }}>
                                {workflowSteps.map((step, index) => (
                                    <Step key={index} active={true}>
                                        <StepLabel>
                                            <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                                {step.label}
                                            </Typography>
                                        </StepLabel>
                                        <StepContent>
                                            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                                                {step.description}
                                            </Typography>
                                        </StepContent>
                                    </Step>
                                ))}
                            </Stepper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <motion.div
                            initial={{ opacity: 0, x: 30 }}
                            animate={inView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
                            transition={{ duration: 0.5 }}
                        >
                            <Box
                                sx={{
                                    p: 3,
                                    borderRadius: '16px',
                                    border: `1px solid ${theme.palette.grey[200]}`,
                                    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.05)',
                                    height: '100%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center',
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    component="h3"
                                    sx={{
                                        fontWeight: 600,
                                        mb: 3,
                                        color: theme.palette.secondary.main,
                                        textAlign: 'center'
                                    }}
                                >
                                    Örnek Müşteri Soruları ve Yanıtları
                                </Typography>

                                <Box sx={{ position: 'relative', minHeight: '320px' }}>
                                    {exampleQuestions.map((example, index) => (
                                        <Card
                                            key={index}
                                            sx={{
                                                mb: 3,
                                                backgroundColor: theme.palette.grey[50],
                                                borderRadius: '12px',
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: 'auto',
                                                opacity: currentQuestionIndex === index ? 1 : 0,
                                                visibility: currentQuestionIndex === index ? 'visible' : 'hidden',
                                                transition: 'opacity 0.5s ease-in-out',
                                            }}
                                        >
                                            <CardContent>
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                                    Müşteri Sorusu:
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                                                    "{example.question}"
                                                </Typography>
                                                <Divider sx={{ my: 2 }} />
                                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
                                                    Helpigo Yanıtı:
                                                </Typography>
                                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                                                    "{example.answer}"
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    ))}
                                </Box>

                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        mt: 2,
                                        position: 'relative',
                                        zIndex: 5
                                    }}
                                >
                                    <IconButton
                                        onClick={handlePrevQuestion}
                                        color="primary"
                                        sx={{
                                            bgcolor: 'white',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            mr: 1,
                                            '&:hover': { bgcolor: 'white', boxShadow: '0 4px 15px rgba(0,0,0,0.15)' }
                                        }}
                                    >
                                        <ArrowBackIosNewIcon fontSize="small" />
                                    </IconButton>

                                    {exampleQuestions.map((_, index) => (
                                        <Box
                                            key={index}
                                            sx={{
                                                width: 8,
                                                height: 8,
                                                borderRadius: '50%',
                                                mx: 0.5,
                                                backgroundColor: currentQuestionIndex === index
                                                    ? theme.palette.primary.main
                                                    : theme.palette.grey[300],
                                                transition: 'background-color 0.3s',
                                                cursor: 'pointer',
                                            }}
                                            onClick={() => {
                                                setAutoPlay(false);
                                                setCurrentQuestionIndex(index);
                                            }}
                                        />
                                    ))}

                                    <IconButton
                                        onClick={handleNextQuestion}
                                        color="primary"
                                        sx={{
                                            bgcolor: 'white',
                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                                            ml: 1,
                                            '&:hover': { bgcolor: 'white', boxShadow: '0 4px 15px rgba(0,0,0,0.15)' }
                                        }}
                                    >
                                        <ArrowForwardIosIcon fontSize="small" />
                                    </IconButton>
                                </Box>

                                <Typography variant="body2" sx={{ color: theme.palette.text.secondary, fontStyle: 'italic', textAlign: 'center', mt: 2 }}>
                                    Helpigo, mağazanıza özel bilgileri kullanarak doğru ve eksiksiz yanıtlar üretir.
                                </Typography>
                            </Box>
                        </motion.div>
                    </Grid>
                </Grid>

                <Box sx={{ mt: 8 }}>
                    <Typography
                        variant="h4"
                        component="h3"
                        sx={{
                            fontWeight: 600,
                            mb: 4,
                            color: theme.palette.secondary.main,
                            textAlign: 'center'
                        }}
                    >
                        Helpigo'nun Özellikleri
                    </Typography>

                    <Grid container spacing={3}>
                        {detailItems.map((item, index) => (
                            <Grid item xs={12} sm={6} md={3} key={index}>
                                <motion.div
                                    initial={{ opacity: 0, y: 20 }}
                                    whileInView={{ opacity: 1, y: 0 }}
                                    transition={{ duration: 0.5, delay: index * 0.1 }}
                                    viewport={{ once: true }}
                                >
                                    <Paper
                                        elevation={0}
                                        sx={{
                                            p: 3,
                                            height: '100%',
                                            borderRadius: '16px',
                                            border: `1px solid ${theme.palette.grey[200]}`,
                                            transition: 'transform 0.3s, box-shadow 0.3s',
                                            '&:hover': {
                                                transform: 'translateY(-10px)',
                                                boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                                                borderColor: theme.palette.primary.main,
                                            },
                                        }}
                                    >
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                width: 50,
                                                height: 50,
                                                borderRadius: '12px',
                                                background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.light} 100%)`,
                                                color: 'white',
                                                mb: 2,
                                                mx: 'auto'
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        <Typography
                                            variant="h6"
                                            component="h3"
                                            sx={{
                                                fontWeight: 600,
                                                mb: 1,
                                                color: theme.palette.secondary.main,
                                                textAlign: 'center'
                                            }}
                                        >
                                            {item.title}
                                        </Typography>

                                        <Typography
                                            variant="body2"
                                            sx={{
                                                color: theme.palette.text.secondary,
                                                textAlign: 'center'
                                            }}
                                        >
                                            {item.description}
                                        </Typography>
                                    </Paper>
                                </motion.div>
                            </Grid>
                        ))}
                    </Grid>
                </Box>
            </Container>
        </Box>
    );
} 